import { createContext, useContext } from 'react';
export const defaultValue = {
  next: () => {},
  back: () => {},
  service: {},
  showFallback: () => {}
};
export const WixFlowContext = /*#__PURE__*/createContext(defaultValue);
export const useWixFlowContext = () => useContext(WixFlowContext);
//# sourceMappingURL=WixFlowContext.js.map